import * as Axios from 'axios';
import BaseService from './BaseService';
import store from '@/store';
import { IUsageSummary, IUserActivity, IPublishTrend, ICustomerActiveUsers } from '@/domain/common';

export default class UsageService extends BaseService {
    public async getSummarySecurityLogs(selectedMonthSummary: string, excludeTestOrgs = false): Promise<IUsageSummary> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/pc/usage/summary`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` },
            params: { selectedMonthSummary, excludeTestOrgs }
        }
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data as IUsageSummary;
    }

    public async getPublishTrend(selectedMonth: string, excludeTestOrgs = false, months = 6): Promise<IPublishTrend> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/pc/usage/publish-trend`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` },
            params: { selectedMonth, months, excludeTestOrgs }
        }
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data as IPublishTrend;
    }

    public async getCustomerActiveUsers(customerId: string, months = 12): Promise<ICustomerActiveUsers> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/pc/usage/customer-active-users`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` },
            params: { customerId, months }
        }
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data as ICustomerActiveUsers;
    }

    public async getCustomerUsers(customerId: string, selectedMonth: string, excludeTestOrgs = false): Promise<IUserActivity[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/pc/usage/customer-users`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` },
            params: { customerId, selectedMonth, excludeTestOrgs }
        }
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data as IUserActivity[];
    }
}
